import {Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractModalComponent} from "../abstract-modal/abstract-modal.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {WarningModalService} from "../../services/warning-modal/warning-modal.service";
import * as _ from 'lodash';
import {PermissionsService} from 'src/app/services/permissions/permissions.service';
import {OrganisationService} from 'src/app/services/organisation/organisation.service';
import {use} from "@js-joda/core";

@Component({
  selector: 'app-domains-modal',
  templateUrl: './domains-modal.component.pug',
  styleUrls: ['./domains-modal.component.scss'],
  standalone: false
})
export class DomainsModalComponent extends AbstractModalComponent implements OnInit {

  @Input() domains!: any;
  @Input() deleteDomains!: any;
  @Input() addDomains!: any;
  @ViewChild('orgForm', {static: false}) orgForm: any;
  deleteDomainClick: EventEmitter<any> = new EventEmitter<any>();
  orgDetails: any;
  loaded = true;
  showValidationError = false;
  domainHandler: any;
  newDomain = '';
  newEmailDomain = '';
  validateDomain = false;
  addEmailDomainList: any = [];
  removeEmailDomainList: any = [];
  emailDomainHandler: any;
  userAllowed = false;
  deletedDomain = '';
  deleteModal: BsModalRef = new BsModalRef();
  validDomain = false;

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService, public permissions: PermissionsService, private modalService: BsModalService, private organisationService: OrganisationService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    
    if (this.deleteDomains) {
      this.removeEmailDomainList = [...this.removeEmailDomainList, ...this.deleteDomains];
    }
    if (this.addDomains) {
      this.addEmailDomainList = [...this.addEmailDomainList, ...this.addDomains];
    }
    
    this.orgDetails = {'domains': this.domains}
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (!this.orgForm.valid || this.orgDetails['domains'].length == 0) {
      return;
    }
    
    if (this.addEmailDomainList.length > 0 || this.removeEmailDomainList.length > 0) {
      this.loaded = false;
      this.emailDomainHandler = {
        add: this.addEmailDomainList,
        remove: this.removeEmailDomainList
      }
      this.event.emit(this.emailDomainHandler)
    }
    
  }

  getForm() {
    return this.orgForm;
  }

  checkDomain(domain) {
    this.validateDomain = false
    if (domain.trim() != '') {
      const regex_at = /[@_!#$%^&*+={}\/<>,?\]`~'"|\\[;:\s]/;
      const matches_at = regex_at.test(domain);
      const regex_hyphen = /^([^-]|[^-].*[^-])$/;
      const matches_uderscore = regex_hyphen.test(domain);
      const regex_period = /[A-Za-z0-9-()]\.[a-zA-z]+/;
      const matches_period = regex_period.test(domain);
      this.validateDomain = !matches_at && matches_period && matches_uderscore;
    }
  }

  add() {
    this.validateDomain = false;
    this.validDomain = true;
    this.messages = [];
    if (!_.includes(this.orgDetails['domains'].map(domain => domain.toLowerCase()), this.newDomain.toLowerCase())) {
      this.organisationService.validateDomains(this.newDomain).subscribe((res) => {
          if (res.message == 'valid domain') {
            this.orgDetails['domains'].push(this.newDomain);
            this.newDomain = "";
            this.validDomain = false;
          }
        },
        (error) => {
          if (error.error['message'] == 'invalid domain') {
            this.setMessages({
              'type': 'danger',
              'message': $localize`Only business email domains can be added`
            });
          }
        })
    } else {
      this.setMessages({
        'type': 'danger',
        'message': $localize`Email domain already exists.`
      })
    }
  }

  addEmailDomain() {
    this.validateDomain = false;
    this.validDomain = true;
    this.messages = [];
    this.newEmailDomain = _.toLower(this.newEmailDomain);
    if (!_.includes(this.orgDetails['domains'].map(domain => domain.toLowerCase()), this.newEmailDomain.toLowerCase())) {
      this.organisationService.validateDomains(this.newEmailDomain).subscribe((res) => {
          if (res.message == 'valid domain') {
            this.orgDetails['domains'].push(this.newEmailDomain);
            this.addEmailDomainList.push(this.newEmailDomain);
            this.newEmailDomain = "";
            this.validDomain = false;
          }
        },
        (error) => {
          if (error.error['message'] == 'invalid domain') {
            this.setMessages({
              'type': 'danger',
              'message': $localize`Only business email domains can be added`
            });
          }
        })
    } else {
      this.setMessages({
        'type': 'danger',
        'message': $localize`Email domain already exists.`
      })
    }
  }

  confirmDeletePopup(domain) {
    this.removeEmailDomainList.push(domain);
    this.domainHandler =  {
      domainToDelete: domain,
      addedDomainList: this.addEmailDomainList,
      removeDomainList: this.removeEmailDomainList
    }
    this._bsModalRef.hide();
    this.deleteDomainClick.emit(this.domainHandler);
  }

  delete(toDelete) {
    _.remove(this.orgDetails['domains'], domain => domain === toDelete);
  }

  deleteEmailDomain(toDelete) {
    _.remove(this.orgDetails['domains'], domain => domain === toDelete);
    this.removeEmailDomainList.push(toDelete);
  }

  protected readonly use = use;
}
